import React , {Component} from 'react';
import ClassImg from '../../assets/images/yoga.png';

export default class GamesList extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div>
            <div className="container-fluid">
            <div className="games-list-main-div">
            <div className="row">
            <div className="col-md-12 col-lg-12"> 
            <div className="row" style={{marginLeft:'0'}}>
            <div className="" style={{marginTop:'-5px', cursor:'pointer'}} onClick={()=>this.props.HandleRouting('all-games')}>
            <h4>Popular Games</h4>
            </div>
           
            <div className="orders-head-line display-none"></div>
            {/* onClick={()=>this.props.HandleRouting('all-games')}*/}
            <p class="display-none" style={{cursor:'pointer'}} onClick={()=>this.props.HandleRouting('all-games')}>View all</p>
            <i class="fa fa-arrow-right orders-head-arrow" style={{cursor:'pointer'}} aria-hidden="true" onClick={()=>this.props.HandleRouting('all-games')}></i>
            </div>
            </div>
            
            <div class="event-list-mobile classes-list">
            <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-image">
            <img src={ClassImg} alt="loading...."/>
            </div>
            </div>

            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-date">
            <h5>Hearts</h5>
            <p>Score the lowest to win</p>
            </div>
            </div>

            
            </div>
            </div>
            <div class="col-12">
            <div className="seperation-line"></div>
            </div>
            <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-image">
            <img src={ClassImg} alt="loading...."/>
            </div>
            </div>

            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-date">
            <h5>Hearts</h5>
            <p>Score the lowest to win</p>
            </div>
           
            </div>

            
            </div>
            </div>
            <div class="col-12">
            <div className="seperation-line"></div>
            </div>
            <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-image">
            <img src={ClassImg} alt="loading...."/>
            </div>
            </div>

            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-date">
            <h5>Hearts</h5>
            <p>Score the lowest to win</p>
            </div>
           
            </div>

            
            </div>
            </div>
            </div>
            <div className="event-list-desktop col-md-12 col-lg-12">
            <div className="classes-list">
            <div className="row">
            <div className="col-sm-6 col-md-4 col-lg-4">
             <div className="classes-img">
             <img src={ClassImg} alt="loading..."/>
             <div className="classes-details">
             <h5>Gentle Stretch Workout 1</h5>
             <p>30 mins-Mobility</p>
             </div>
             </div>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-4">
            <div className="classes-img">
            <img src={ClassImg} alt="loading..."/>
            <div className="classes-details">
            <h5>Gentle Stretch Workout 1</h5>
            <p>30 mins-Mobility</p>
            </div>
            </div>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-4">
            <div className="classes-img">
            <img src={ClassImg} alt="loading..."/>
            <div className="classes-details">
            <h5>Gentle Stretch Workout 1</h5>
            <p>30 mins-Mobility</p>
            </div>
            </div>
            </div>
            
            </div>
            </div>
            </div>
 
            </div>
            
            </div>
            
            </div>
 
            </div>
        )
    }
}